export default __webpack_public_path__ + "static/media/loggly-icon.bc376222.svg";